/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OWEventType
 */
export interface OWEventType {
    /**
     * The name of the event type (e.g., "KILL", "DEATH")
     * @type {string}
     * @memberof OWEventType
     */
    name: string;
    /**
     * The structure/schema of the event data
     * @type {object}
     * @memberof OWEventType
     */
    dataStructure: object;
    /**
     * Whether the event data must match the dataStructure exactly or partially
     * @type {boolean}
     * @memberof OWEventType
     */
    partialMatch: boolean;
    /**
     * The ID of the game this event type is associated with
     * @type {string}
     * @memberof OWEventType
     */
    game?: string;
}

/**
 * Check if a given object implements the OWEventType interface.
 */
export function instanceOfOWEventType(value: object): value is OWEventType {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('dataStructure' in value) || value['dataStructure'] === undefined) return false;
    if (!('partialMatch' in value) || value['partialMatch'] === undefined) return false;
    return true;
}

export function OWEventTypeFromJSON(json: any): OWEventType {
    return OWEventTypeFromJSONTyped(json, false);
}

export function OWEventTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWEventType {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'dataStructure': json['dataStructure'],
        'partialMatch': json['partialMatch'],
        'game': json['game'] == null ? undefined : json['game'],
    };
}

export function OWEventTypeToJSON(json: any): OWEventType {
    return OWEventTypeToJSONTyped(json, false);
}

export function OWEventTypeToJSONTyped(value?: OWEventType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'dataStructure': value['dataStructure'],
        'partialMatch': value['partialMatch'],
        'game': value['game'],
    };
}

